export default __webpack_public_path__ + "static/media/Img_panels.55320169.svg";